// Design System Spacing Tokens
// Consistent spacing scale based on 8px grid system

export const spacingScale = {
  0: '0px',
  1: '4px',   // 0.25rem
  2: '8px',   // 0.5rem  - Base unit
  3: '12px',  // 0.75rem
  4: '16px',  // 1rem
  5: '20px',  // 1.25rem
  6: '24px',  // 1.5rem
  7: '28px',  // 1.75rem
  8: '32px',  // 2rem
  10: '40px', // 2.5rem
  12: '48px', // 3rem
  16: '64px', // 4rem
  20: '80px', // 5rem
  24: '96px', // 6rem
  32: '128px', // 8rem
  40: '160px', // 10rem
  48: '192px', // 12rem
  56: '224px', // 14rem
  64: '256px', // 16rem
};

// Semantic spacing tokens
export const spacing = {
  // Component spacing
  component: {
    xs: spacingScale[1],   // 4px
    sm: spacingScale[2],   // 8px
    md: spacingScale[4],   // 16px
    lg: spacingScale[6],   // 24px
    xl: spacingScale[8],   // 32px
  },
  
  // Layout spacing
  layout: {
    xs: spacingScale[4],   // 16px
    sm: spacingScale[6],   // 24px
    md: spacingScale[8],   // 32px
    lg: spacingScale[12],  // 48px
    xl: spacingScale[16],  // 64px
    xxl: spacingScale[24], // 96px
  },
  
  // Form spacing
  form: {
    fieldGap: spacingScale[4],     // 16px between form fields
    sectionGap: spacingScale[8],   // 32px between form sections
    labelGap: spacingScale[1],     // 4px between label and input
    helpTextGap: spacingScale[1],  // 4px between input and help text
  },
  
  // Card spacing
  card: {
    padding: {
      xs: spacingScale[3],  // 12px
      sm: spacingScale[4],  // 16px
      md: spacingScale[6],  // 24px
      lg: spacingScale[8],  // 32px
    },
    gap: spacingScale[4],   // 16px between card elements
    margin: spacingScale[4], // 16px margin around cards
  },
  
  // Button spacing
  button: {
    padding: {
      xs: `${spacingScale[1]} ${spacingScale[3]}`,    // 4px 12px
      sm: `${spacingScale[2]} ${spacingScale[4]}`,    // 8px 16px
      md: `${spacingScale[3]} ${spacingScale[6]}`,    // 12px 24px
      lg: `${spacingScale[4]} ${spacingScale[8]}`,    // 16px 32px
    },
    gap: spacingScale[2], // 8px between button icon and text
  },
  
  // List spacing
  list: {
    item: {
      padding: spacingScale[3], // 12px
      gap: spacingScale[2],     // 8px between list item elements
    },
    section: spacingScale[4],   // 16px between list sections
  },
  
  // Table spacing
  table: {
    cell: {
      padding: spacingScale[3], // 12px
    },
    row: {
      height: spacingScale[12], // 48px minimum row height
    },
  },
  
  // Navigation spacing
  navigation: {
    menuItem: spacingScale[3],  // 12px padding
    breadcrumb: spacingScale[2], // 8px gap
  },
  
  // Modal/Dialog spacing
  modal: {
    padding: spacingScale[6],   // 24px
    gap: spacingScale[4],       // 16px between modal elements
  },
};

// Container max-widths
export const containers = {
  xs: '480px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1536px',
  full: '100%',
};

// Responsive breakpoints
export const breakpoints = {
  xs: '0px',
  sm: '600px',
  md: '900px',
  lg: '1200px',
  xl: '1536px',
};

// Z-index scale
export const zIndex = {
  hide: -1,
  base: 0,
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  modal: 1040,
  popover: 1050,
  tooltip: 1060,
  toast: 1070,
  maximum: 9999,
};

export default {
  ...spacing,  // Spread spacing properties at root level for backward compatibility
  scale: spacingScale,
  semantic: spacing,
  containers,
  breakpoints,
  zIndex,
};